import { useRef, useState } from 'react';
import { useStateInRef } from '../../../utils/useStateInRef';
export function useOverlayEntries() {
    const [entries, setEntries] = useState([]);
    const entriesIncludingThisTick = useRef(entries);
    function updateEntries(update) {
        entriesIncludingThisTick.current = update(entriesIncludingThisTick.current);
        setEntries(entriesIncludingThisTick.current);
    }
    const openDialogs = entries.filter((entry)=>entry.isOpen && entry.presentation !== 'sheet');
    return {
        entries,
        updateEntries,
        getUpdateEntries: useStateInRef(updateEntries),
        readEntriesIncludingThisTick: ()=>entriesIncludingThisTick.current,
        readOpenDialogs: useStateInRef(openDialogs)
    };
}
